import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Chip,
  Icon,
} from '@material-ui/core';
import 'swiper/css/swiper.css';

import FilterIcon from '../../../../../components/icons/FilterIcon';
import { useSchedule } from '../context';
import useStyles from './styles';
import ProfessionalModal from './ProfessionalModal';

const ScheduleFilters = () => {
  const classes = useStyles();
  const professionals = useSelector(
    state => state.appointments.professionals.list,
  );
  const [anchorMenu, setAnchorMenu] = useState(null);
  const [openProfessionalModal, setOpenProfessionalModal] = useState(false);
  const {
    filterProfessional,
    setFilterProfessional,
    refreshSchedule,
  } = useSchedule();

  const handleClickFilter = useCallback(event => {
    setAnchorMenu(event.currentTarget);
  }, []);

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const handleClickMenuItem = useCallback(item => {
    closeMenu();
    switch (item) {
      case 'professional':
        setOpenProfessionalModal(true);
        break;
      default:
    }
  }, []);

  const handleCloseProfessionalModal = useCallback(() => {
    setOpenProfessionalModal(false);
  }, []);

  const handleClearProfessional = useCallback(() => {
    setFilterProfessional(null);
  }, [setFilterProfessional]);

  return (
    <Box className={classes.container}>
      {filterProfessional && (
        <Box className="applied-filter-container">
          <Chip
            variant="outlined"
            color="default"
            onDelete={handleClearProfessional}
            icon={<Icon fontSize="small">person</Icon>}
            className="applied-filter-chip"
            label={
              <Typography className="applied-filter-text" variant="caption">
                {professionals[filterProfessional].name}
              </Typography>
            }
          />
        </Box>
      )}
      <IconButton color="primary" onClick={handleClickFilter}>
        <FilterIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorMenu}
        keepMounted
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => handleClickMenuItem('professional')}>
          <Typography variant="body2">Profissional</Typography>
        </MenuItem>
      </Menu>
      {openProfessionalModal && (
        <ProfessionalModal onExited={handleCloseProfessionalModal} />
      )}
      <IconButton className="button-refresh" onClick={refreshSchedule}>
        <Icon>refresh</Icon>
      </IconButton>
    </Box>
  );
};

export default ScheduleFilters;
